export default __webpack_public_path__ + "static/media/icongpriest.736ffd51.png";